import { Component, Input, OnInit } from '@angular/core';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import * as data from 'src/assets/data.json';

@Component({
  selector: 'app-scores-chart',
  templateUrl: './scores-chart.component.html',
  styleUrls: ['./scores-chart.component.css']
})
export class ScoresChartComponent implements OnInit {
  @Input() patientId: string = ''
  public ChartType: any = 'horizontalBar';
  firstCopy = false;
  private backgroundColours:any = [];

  // data
  public barChartData: Array<number> = [];
  public ChartData: Array<any> = [];
  // labels
  public barChartLabels: Array<any> = [];
  
  public barChartOptions: any ={}
  constructor(  ) { }
  
  ngOnInit(): void {
    let record: { [key: string]: any; } = data.data.find(x => x.info.Id == this.patientId)!!.scores
    let keys = Object.keys(record)
    for(let i=0; i< keys.length; i++){
      this.barChartLabels.push(keys[i].replace(' score',''))
      this.barChartData.push(record[keys[i]])
    }

    for(let i=0;i<this.barChartLabels.length;i++){
      let color="#b1fc03";
      if(this.barChartLabels[i]=="No Finding"){
        if(this.barChartData[i]>=0 && this.barChartData[i]<20){color="#4F6F51"}
        else if (this.barChartData[i]>=20 && this.barChartData[i]<40){color="#3C7940"}
        else if (this.barChartData[i]>=40 && this.barChartData[i]<60){color="#27832D"}
        else if (this.barChartData[i]>=60 && this.barChartData[i]<80){color="#0B9414"}
        else if (this.barChartData[i]>=80 && this.barChartData[i]<=100){color="#00A40B"} 
      }
      else{
        if(this.barChartData[i]>=0 && this.barChartData[i]<20){color="#FFF500"}
        else if (this.barChartData[i]>=20 && this.barChartData[i]<40){color="#FFB700"}
        else if (this.barChartData[i]>=40 && this.barChartData[i]<60){color="#FF7C00"}
        else if (this.barChartData[i]>=60 && this.barChartData[i]<80){color="#FF4900"}
        else if (this.barChartData[i]>=80 && this.barChartData[i]<=100){color="#FF1300"} 
      }
      this.backgroundColours.push(color)
    }
    this.ChartData =[
      { data: this.barChartData,
        label: "Scores Result",
        backgroundColor: this.backgroundColours,
        hoverBackgroundColor: this.backgroundColours,
        borderColor: "none",
        borderWidth: 0,
      }
    ];
    this.barChartOptions = {
      plugins: {
        datalabels: {
          color: '#dadde0',
          anchor: 'end',
          align: 'end',
        }
      },
      title: {
          display: true,
          text: 'AI Analysis Score'
      },
      legend: { display: false },
      responsive: true,
      scales : {
        yAxes: [{
          ticks: {
            fontColor: "#dadde0",
            beginAtZero: true
          },
          gridLines: {
            show: true,
            color: 'rgba(255, 255, 255, 0.2)'
          }
        }],
        xAxes: [{
          ticks: {
            //max: Math.max(...this.barChartData) + 10, //max value of x-axis set to 10 points higher than the max value
            max:100, //max value of x-axis set to 100
            fontColor: "#dadde0",
            beginAtZero: true
          },
          gridLines: {
            show: true,
            color: 'rgba(255, 255, 255, 0.3)',
          }
          }],
      }
    };
  }
  

  public barChartPlugins = [pluginDataLabels];

  public chartClicked(e: any): void {
    console.log(e);
  }
  public chartHovered(e: any): void {
    console.log(e);
  }

}
